import { Alert } from '@economic/taco';
import { Trans } from '@lingui/macro';
import React from 'react';

export function EmailOrEInvoiceSendingLimitExceededAlert() {
    return (
        <Alert state="error" className="mt-1">
            <Trans>Sending limit exceeded. Please contact support.</Trans>
        </Alert>
    );
}
